<template>
  <!--账号密码登录-->
  <div id="pwdlogin">
    <h2 class="title">
      <a @click="back" class="prev"></a>
    </h2>
    <header>
      <div class="logo"></div>
    </header>
    <nav class="title">
      <a class="active">学习账号登录</a>
      <router-link :to="{name: 'MobileLogin', query: {backto: this.backTo}}">手机快捷登录</router-link>
    </nav>
    <ul class="main">
      <li class="tel">
        <input type="text" name="number" placeholder="请输入账号\手机号" required="" v-model="number">
      </li>
      <li class="newpwd">
        <input type="password" name="password" placeholder="请输入密码" maxlength="18" v-model="password" v-on:keyup.13="postAccount()">
      </li>
      <li>
        <input type="button" value="登录" v-on:click="postAccount()">
      </li>
    </ul>
    <div class="cue">
      <label><input type="checkbox" checked> 用户注册协议</label>
      <a @click="gotoForget">忘记密码？</a>
    </div>

    <!--第三方登录-->
    <div class="thirdlogin" style="display: none">
      <h2>第三方登录</h2>
      <div class="cc">
        <a href=""><img src="../../assets/icon/pwdlogin_icon_wx.png" alt="">微信</a>
        <a href=""><img src="../../assets/icon/pwdlogin_icon_qq.png" alt="">QQ</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PwdLogin',
  data () {
    return {
      number: this.$store.state.loginname, // 登录账号一般为手机号待定其他类型账号
      password: '', // 登录密码 长度 6 -18 位
      backTo: this.$route.query.backto ? this.$route.query.backto : ''
    }
  },
  mounted () {

  },
  methods: {
    postAccount () {
      let data = {
        number: this.number,
        password: this.password
      }
      if (!data.number) {
        alert('用户名不能为空')
        return false
      }
      if (!data.password) {
        alert('密码不能为空')
        return false
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_account_login',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.$store.dispatch('alterName', res.data.data.name)
            this.$store.dispatch('alterNickname', res.data.data.nickname)
            this.$store.dispatch('alterPeriod', res.data.data.period)
            this.$store.dispatch('alterPortrait', res.data.data.portrait)
            this.$store.dispatch('alterSchool', res.data.data.school_name)
            this.$store.dispatch('alterSubject', res.data.data.subject)
            this.$store.dispatch('alterToken', res.data.data.token)
            this.$store.dispatch('alterUid', res.data.data.uid)
            this.$store.dispatch('alterUserid', res.data.data.user_id)
            this.$store.dispatch('alterVipname', res.data.data.vip_name)
            this.$store.dispatch('alterViptime', res.data.data.vip_time)
            this.$store.dispatch('alterLoginName', this.number)
            console.log(this.$store.state.name)
            console.log(this.$store.state.nickname)
            console.log(this.$store.state.period)
            console.log(this.$store.state.portrait)
            console.log(this.$store.state.school)
            console.log(this.$store.state.subject)
            console.log(this.$store.state.token)
            console.log(this.$store.state.uid)
            console.log(this.$store.state.userid)
            console.log(this.$store.state.vipname)
            console.log(this.$store.state.viptime)
            console.log(this.$store.state.loginname)
            // alert('登录成功')
            if (this.backTo) {
              this.$router.push({name: this.backTo})
            } else {
              this.back()
            }
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (this.backTo) {
        this.$router.push({name: this.backTo})
      } else if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    gotoForget () {
      if (this.backTo) {
        this.$router.push({name: 'PwdForget', query: {backto: this.backTo}})
      } else {
        this.$router.push({name: 'PwdForget', query: {backto: 'PersonInfo'}})
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  #pwdlogin
    h2.title
      position: absolute
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        z-index: 100
        display: block
        width: .8rem
        height: .8rem
        background-color: transparent
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #fff
          border-bottom: .03rem solid #fff
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    header
      position: relative
      width: 7.5rem
      height: 3.58rem
      background: url(../../assets/img/pwdforget_bg_head.png) no-repeat center top
      -webkit-background-size: 7.5rem 2.98rem
      background-size: 7.5rem 2.98rem
      .logo
        position: absolute
        bottom: 0
        left: 50%
        width: 1.2rem
        height: 1.2rem
        background: url(../../assets/icon/pwdforget_icon_logo.png) no-repeat center #fff
        -webkit-background-size: 1.12rem
        background-size: 1.12rem
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        -webkit-transform: translate(-50%, 0)
        -moz-transform: translate(-50%, 0)
        -ms-transform: translate(-50%, 0)
        -o-transform: translate(-50%, 0)
        transform: translate(-50%, 0)
        box-shadow:0rem 0.04rem 0.08rem 0rem rgba(172,229,255,0.3)
    nav.title
      position: relative
      display: flex
      justify-content: space-around
      align-items: center
      width: 7.5rem
      height: .56rem
      margin: .38rem 0
      text-align: center
      a
        line-height: .56rem
        font-size: .4rem
        color: #050505
        font-weight: 600
        &:nth-of-type(2)
          &::before
            content: ""
            position: absolute
            top: .02rem
            left: 50%
            width: .04rem
            height: .56rem
            background-color: #F4F4F4
            -webkit-transform: translate(-50%, 0)
            -moz-transform: translate(-50%, 0)
            -ms-transform: translate(-50%, 0)
            -o-transform: translate(-50%, 0)
            transform: translate(-50%, 0)
        &.active
          color: #1E81F2
    ul.main
      width: 7.5rem
      padding: 0 .4rem .8rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      li
        position: relative
        width: 6.7rem
        height: 1rem
        line-height: 1rem
        background: url(../../assets/icon/pwdforget_icon_user.png) no-repeat center left
        -webkit-background-size: .4rem
        background-size: .4rem
        border-bottom: .04rem solid #F3F3F3
        padding: 0 0 0 .6rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &.newpwd, &.tel
          input
            width: 100%
        &:last-child
          background: none
          border: none
          padding: 0
        &:nth-of-type(2)
          background-image: url(../../assets/icon/pwdforget_icon_lock.png)
        input[type=text]
          font-size: .28rem
        input[type=submit],input[type=button]
          width: 6.7rem
          height: .8rem
          background-color: #1E81F2
          margin-top: .6rem
          font-size: .32rem
          color: #fff
          text-align: center
          -webkit-border-radius: .4rem
          -moz-border-radius: .4rem
          border-radius: .4rem
    ::-webkit-input-placeholder
      color: #D8D8D8
    .cue
      display: flex
      justify-content: space-between
      align-items: center
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      label
        font-size: .28rem
        color: #666
        input[type=checkbox]
          position: relative
          top: -.02rem
      a
        font-size: .28rem
        color: #666
    .thirdlogin
      margin-top: 1.08rem
      h2
        position: relative
        font-size: .28rem
        color: #6666
        font-weight: 600
        text-align: center
        &::before, &::after
          content: ""
          position: absolute
          top: .2rem
          left: .48rem
          display: inline-block
          width: 2.1rem
          height: .04rem
          background-color: #F3F3F3
        &::after
          left: auto
          right: .48rem
      .cc
        display: flex
        justify-content: space-between
        align-items: center
        width: 2.78rem
        margin: .4rem auto 0
        a
          font-size: .28rem
          color: #ccc
          text-align: center
          img
            display: block
            width: .8rem
            height: .8rem
            margin: 0 auto .2rem
</style>



// WEBPACK FOOTER //
// src/components/login/PwdLogin.vue